import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader } from "@/layouts/AdminLayout";
import { FormDialog } from "@/components/FormDialog";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { clientFields } from "@/lib/forms";

export default function Clients() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => api.get("/clients", { params: { q: q || undefined } }).then((r) => setItems(r.data)), 200);
    return () => clearTimeout(t);
  }, [q]);

  const create = async (form) => {
    const { data } = await api.post("/clients", form);
    nav(`/admin/clientes/${data.id}`);
  };

  return (
    <div>
      <PageHeader eyebrow={`${items.length} registros`} title="Clientes">
        {can("clients.write") && <Button onClick={() => setOpen(true)} data-testid="new-client-button"><Plus className="mr-1 h-4 w-4" />Nuevo cliente</Button>}
      </PageHeader>
      <div className="relative mb-4 max-w-md">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cliente, contacto, correo o teléfono" className="h-10 pl-9" data-testid="client-search-input" />
      </div>
      <div className="overflow-x-auto rounded-xl border border-border bg-card/30">
        <Table data-testid="clients-table">
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              {["Empresa / nombre", "Contacto", "Teléfono", "Correo", "Estado"].map((h) => <TableHead key={h} className="font-mono text-[11px] uppercase tracking-wider">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={5} className="py-12 text-center text-muted-foreground">Sin clientes</TableCell></TableRow>}
            {items.map((c) => (
              <TableRow key={c.id} className="cursor-pointer" onClick={() => nav(`/admin/clientes/${c.id}`)} data-testid={`client-row-${c.id}`}>
                <TableCell className="font-medium">{c.name}</TableCell>
                <TableCell>{c.contact_name}</TableCell>
                <TableCell className="font-mono text-xs">{c.phone}</TableCell>
                <TableCell className="text-sm">{c.email}</TableCell>
                <TableCell><span className={c.status === "activo" ? "text-emerald-400" : "text-muted-foreground"}>{c.status === "activo" ? "Activo" : "Inactivo"}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <FormDialog open={open} onOpenChange={setOpen} title="Nuevo cliente" fields={clientFields} onSubmit={create} testid="client-form" />
    </div>
  );
}
